import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function Integrations() {
  const handleConnect = () => {
    console.log('Connect to Tarion/Insurer');
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Integrations</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-base font-medium">Tarion/Insurer Integration</p>
            <p className="text-muted-foreground text-sm">Connect with Tarion or other insurer systems.</p>
          </div>
          <Button onClick={handleConnect}>Connect</Button>
        </div>
      </CardContent>
    </Card>
  );
}
